/*@ngInject*/
const UIClassCodeStopEventDirective = function () {

    let linkFunction = function ($scope, $elm, $attrs) {
        let element = $($elm);

        if ($attrs && $attrs.uiClassCodeStopEvent) {
            let catchStopableEvent = function (e) {
                if (e.type === $attrs.uiClassCodeStopEvent && $(e.currentTarget).parent().hasClass('disabled')) {
                    e.stopPropagation();
                    e.preventDefault();
                }
            };

            element.on($attrs.uiClassCodeStopEvent, 'a', catchStopableEvent);

            $scope.$on('$destroy', function () {
                element.off($attrs.uiClassCodeStopEvent, catchStopableEvent);
            });
        }
    };

    return {
        restrict: 'A',
        replace: false,
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiClassCodeStopEvent', UIClassCodeStopEventDirective);
